import { defineMessages } from 'react-intl';

export default defineMessages({
  headingWatching: {
    id: 'frontbucket.repository.subscriptionsDialog.headingWatching',
    description:
      'Heading of the modal dialog when managing repository subscription settings and the user is watching the repository',
    defaultMessage: 'You are watching this repository',
  },
  headingNotWatching: {
    id: 'frontbucket.repository.subscriptionsDialog.headingNotWatching',
    description:
      'Heading of the modal dialog when managing repository subscription settings and the user is not watching the repository',
    defaultMessage: 'You are not watching this repository',
  },
  actionManageNotifications: {
    id: 'frontbucket.repository.subscriptionsDialog.actionManageNotifications',
    description: 'Link to settings page to manage all Bitbucket nofications',
    defaultMessage: 'Manage all notifications',
  },
  buttonWatchRepository: {
    id: 'frontbucket.repository.subscriptionsDialog.buttonWatchRepository',
    description: 'Action button to start watching a repository',
    defaultMessage: 'Watch this repository',
  },
  buttonUnwatchRepository: {
    id: 'frontbucket.repository.subscriptionsDialog.buttonUnwatchRepository',
    description: 'Action button to stop watching a repository',
    defaultMessage: 'Stop watching',
  },
  headingSettingsList: {
    id: 'frontbucket.repository.subscriptionsDialog.headingSettingsList',
    description: 'Heading above the list of repository subscription settings',
    defaultMessage: 'Subscribe to notifications about all',
  },
  labelPullrequests: {
    id: 'frontbucket.repository.subscriptionsDialog.labelPullrequests',
    description:
      'Label for the `pull requests` repository subscription setting',
    defaultMessage: 'Pull requests',
  },
  labelIssues: {
    id: 'frontbucket.repository.subscriptionsDialog.labelIssues',
    description: 'Label for the `issues` repository subscription setting',
    defaultMessage: 'Issues',
  },
  labelCommits: {
    id: 'frontbucket.repository.subscriptionsDialog.labelCommits',
    description: 'Label for the `commits` repository subscription setting',
    defaultMessage: 'Commits',
  },
  labelWiki: {
    id: 'frontbucket.repository.subscriptionsDialog.labelWiki',
    description: 'Label for the `wiki` repository subscription setting',
    defaultMessage: 'Wiki changes',
  },
  labelForks: {
    id: 'frontbucket.repository.subscriptionsDialog.labelForks',
    description: 'Label for the `forks` repository subscription setting',
    defaultMessage: 'Forks',
  },
  labelPipelines: {
    id: 'frontbucket.repository.subscriptionsDialog.labelPipelines',
    description: 'Label for the `pipelines` repository subscription setting',
    defaultMessage: 'Pipelines',
  },
  errorHeading: {
    id: 'frontbucket.repository.subscriptionsDialog.errorHeading',
    description:
      'Heading for the error message when there is a problem getting the notification settings',
    defaultMessage: 'Something went wrong...',
  },
  errorDescription: {
    id: 'frontbucket.repository.subscriptionsDialog.errorDescription',
    description:
      'A message explaining to the user that is was error loading the notification settings',
    defaultMessage: 'We were unable to get your notification settings.',
  },
  errorAction: {
    id: 'frontbucket.repository.subscriptionsDialog.errorAction',
    description:
      'Action link for the user to try to fetch the notification settings when there is an error',
    defaultMessage: 'Try again',
  },
});
